import { Scene } from "phaser";
import store from "@/store";
import router from "@/router";
import axios from "axios";
import moment from "moment";
import i18n from "@/plugins/i18n";

export default class LandingScene extends Scene {
  constructor() {
    super({ key: "LandingScene" });
  }

  init(data) {
    this.avatar = data.avatar;
    this.ladder = data.ladder;
    this.blueStar = data.blueStar;
    this.game = data.game;
    this.end = data.end;
    this.wizard = data.wizard;
    this.questions = data.questions;
    this.timestampReset = data.timestampReset;
    this.colors = data.colors
    this.env = data.env
    this.schoolYear = data.schoolYear
    this.classroomMonth = data.classroomMonth
    this.isHasSpecialItem = data.isHasSpecialItem
  }

  selectedOption = -1;
  avatarObject = [];
  avatarX = 260;
  avatarY = 730;
  avatarJY = 590;
  tileTween;
  tileTweenBorder;
  currentColor;
  nextColor;
  tilesGroup;
  isClicked = false;
  timerInterval;
  rechargebale = false;
  footprintTweens;
  _mark_correct;
  
  create() {
    this.avatarY = 730;
    this.avatarJY = 590;
    this.isClicked = false;
    this.friends = this.registry.get('towerStrangers') || [];

    this._backgroundImage = this.add
      .image(0, 0, "imgBackground")
      .setDisplaySize(480, 854)
      .setOrigin(0);

    this.blustartBoard = this.add
      .image(420, 95, "imgScorePanel")
      .setDisplaySize(100, 50)
      .setDepth(2);

    this._bluestar = this.add
      .image(430, 82, "C000040")
      .setDisplaySize(30, 27)
      .setOrigin(0)
      .setDepth(2);

    this.starText = this.add
      .text(390, 93, "" + this.blueStar, {
        fontFamily: "Sassoon, sans-serif",
        fontSize: 30,
        color: "#000000",
      })
      .setOrigin(0, 0.5)
      .setFontStyle("bold")
      .setDepth(2);

    this.footprintBoard = this.add
      .image(420, 155, "imgScorePanel")
      .setDisplaySize(100, 60)
      .setDepth(2);

    this._footprint = this.add
      .image(430, 135, "footprint")
      .setDisplaySize(30, 30)
      .setOrigin(0)
      .setDepth(2);

    this.footprintText = this.add
      .text(390, 148, "" + this.ladder, {
        fontFamily: "Sassoon, sans-serif",
        fontSize: 30,
        color: "#000000",
      })
      .setOrigin(0, 0.5)
      .setFontStyle("bold")
      .setDepth(2);

    this.resetText = this.add
      .text(380, 172, `${i18n.t("string.resetIn")} 00:00:00`, {
        fontFamily: "Sassoon, sans-serif",
        fontSize: 10,
        color: "#000000",
      })
      .setOrigin(0, 0.5)
      .setDepth(2);

    let textResetWidth = this.resetText.width;
    this.resetText.setX(420 - textResetWidth / 2);

    this.settingBtn = this.add
      .image(440, 40, "imgSettingBtn")
      .setScale(0.6)
      .setDepth(2)
      .setInteractive({ useHandCursor: true })
      .on("pointerdown", this.clickSetting, this);

    this.closeBtn = this.add
      .image(40, 40, "homeBtnImage")
      .setScale(0.6)
      .setDepth(2)
      .setInteractive({ useHandCursor: true })
      .on("pointerdown", this.clickClose, this);

    this.resetBtn = this.add
      .image(440, 220, "resetBtnImage")
      .setScale(0.1)
      .setDepth(2)
      .setInteractive({ useHandCursor: true })
      .on("pointerdown", this.resetLevel, this);


    this.currentColor = this.colors[this.game.currentFloor % 10];
    this.nextColor = this.colors[(this.game.currentFloor + 1) % 10];

    this.sfxAvatarJump = this.sound.add("sfxAvatarJump");
    this.sfxNextFloor = this.sound.add("sfxNextFloor");
    this.sfxTransition = this.sound.add("sfxTransition");
    this.simpleClickSound = this.sound.add("simpleClick");
    this.sfxError = this.sound.add("sfxError");
    this.sfxEmoji = this.sound.add("sfxEmoji");

    this.modelbg = this.add
      .rectangle(240, 377, 408, 100, 0xffffff)
      .setDepth(9)
      .setAlpha(0);

    if (
      store.state.miniGame &&
      store.state.miniGame.data &&
      store.state.miniGame.data.star >= 0
    ) {
      this.collectStar();
    }
    if (this.timestampReset == null) {
      this.timestampReset = moment();
    }
    this.tick();
    this.timerInterval = setInterval(this.tick.bind(this), 1000);

    this.spriteJump = this.add
      .sprite(0, 0, "spriteJump")
      .setScale(2)
      .setAlpha(0)
      .setDepth(5);
    this.anims.create({
      key: "avatarJump",
      frames: this.anims.generateFrameNumbers("spriteJump", {
        frames: [0, 1, 2, 3],
      }),
      frameRate: 5,
    });
    this.tilesGroup = this.add.group();
    this._platformBig_002_end = this.add
      .image(65, -383 - 253 - 140 * 6, "platformBig_001")
      .setDisplaySize(350, 583)
      .setOrigin(0)
      .setTint(0x666666);
    this.tilesGroup.add(this._platformBig_002_end);
    this._arrowRight_2 = this.add
      .image(85, -383 - 400 - 240 - 35, "arrowRight")
      .setDisplaySize(75, 75)
      .setOrigin(0)
      .setTint(0x666666);
    this.tilesGroup.add(this._arrowRight_2);
    this._platform_002_magic = this.add
      .image(115, -253 - 140 * 5, "platform_001")
      .setDisplaySize(250, 150)
      .setOrigin(0)
      .setTint(0x666666)
      .setDepth(2);
    this.tilesGroup.add(this._platform_002_magic);
    this._hamochi_wizard_2 = this.add
      .image(250, -253 - 140 * 4 - 200, "hamochiWizard")
      .setDisplaySize(100, 100)
      .setOrigin(0)
      .setTint(0x666666)
      .setDepth(2);
    this.tilesGroup.add(this._hamochi_wizard_2);
    for (var j = 0; j < this.questions.length; j++) {
      this["_platform_002_" + j] = this.add
        .image(115, -253 - 140 * (4 - j), "platform_001")
        .setDisplaySize(250, 150)
        .setOrigin(0)
        .setDepth(this.questions.length - j + 1)
        .setTint(0x666666);
      this.tilesGroup.add(this["_platform_002_" + j]);

      if (this.game.currentTile - 1 < j) {
        this["_platform_002_" + j].setTint(0x666666);
      }
    }

    this._platformBig_001_end = this.add
      .image(65, -383, "platformBig_001")
      .setDisplaySize(350, 583)
      .setOrigin(0)
      .setTint(0x666666);

    this._iconPOUNCH = this.add
      .image(290, -5, "iconPOUNCH")
      .setDisplaySize(100, 100)
      .setOrigin(0)
      .setTint(0x666666);
    this.tilesGroup.add(this._iconPOUNCH);

    this.tilesGroup.add(this._platformBig_001_end);

    this.floorText_1 = this.add
      .text(0, 25, i18n.t("miniGames.towerClimbing.floor"), {
        fontFamily: "Sassoon, sans-serif",
        fontSize: 30,
        color: "#FFFFFF",
      })
      .setOrigin(0, 0.5)
      .setDepth(5)
      .setAlpha(0.5)
      .setShadow(-5, 5, "rgba(0,0,0,0.5)", 0);
    let textFloortWidth = this.floorText_1.width;
    this.floorText_1.setX(240 - textFloortWidth / 2);
    this.floorTextNumber_1 = this.add
      .text(0, 70, this.game.currentFloor + "", {
        fontFamily: "Sassoon, sans-serif",
        fontSize: 70,
        color: "#FFFFFF",
      })
      .setOrigin(0, 0.5)
      .setDepth(5)
      .setAlpha(0.5)
      .setShadow(-5, 5, "rgba(0,0,0,0.5)", 0);

    let textWidth = this.floorTextNumber_1.width;
    this.floorTextNumber_1.setX(240 - textWidth / 2);

    this.tilesGroup.add(this.floorText_1);
    this.tilesGroup.add(this.floorTextNumber_1);
    this._arrowRight_1 = this.add
      .image(85, 35, "arrowRight")
      .setDisplaySize(75, 75)
      .setOrigin(0)
      .setTint(0x666666);
    this.tilesGroup.add(this._arrowRight_1);

    this._arrowLeft_2 = this.add
      .image(330, -385, "arrowLeft")
      .setDisplaySize(75, 75)
      .setOrigin(0);
    this.tilesGroup.add(this._arrowLeft_2);
    this._platform_001_magic = this.add
      .image(115, 140, "platform_001")
      .setDisplaySize(250, 150)
      .setOrigin(0)
      .setTint(0x666666)
      .setDepth(2);

    this.tilesGroup.add(this._platform_001_magic);

    this._hamochi_wizard_1 = this.add
      .image(250, 80, "hamochiWizard")
      .setDisplaySize(100, 120)
      .setOrigin(0)
      .setTint(0x666666)
      .setDepth(2);
    this.tilesGroup.add(this._hamochi_wizard_1);

    for (var i = 0; i < this.questions.length; i++) {
      this["_platform_001_" + i] = this.add
        .image(115, 140 * (4 - i), "platform_001")
        .setDisplaySize(250, 150)
        .setOrigin(0)
        .setDepth(this.questions.length - i + 1)
        .setTint("0x" + this.currentColor);

      this["_platform_icon_" + i] = this.add
        .image(250, 140 * (4 - i) - 40, "icon" + this.questions[i].gameCode)
        .setDisplaySize(100, 100)
        .setOrigin(0)
        .setDepth(this.questions.length - i + 2);

      this.tilesGroup.add(this["_platform_001_" + i]);
      this.tilesGroup.add(this["_platform_icon_" + i]);
      if (this.game.currentTile - 1 == i) {
        this._platform_small_border_1 = this.add
          .image(115, 140 * (4 - i), "platformSmallBorder")
          .setDisplaySize(250, 150)
          .setOrigin(0)
          .setDepth(this.questions.length - i + 1);

        if (this.game.currentTile != 1) {
          this.avatarY = 140 * (5 - i);
          this.avatarJY = this.avatarY - 140;
        }
        this.tileTweenBorder = this.tweens.add({
          targets: this._platform_small_border_1,
          y: 140 * (4 - i) - 10,
          duration: 1500,
          yoyo: true,
          repeat: -1,
        });

        this.tileTween = this.tweens.add({
          targets: this["_platform_001_" + i],
          y: 140 * (4 - i) - 10,
          duration: 1500,
          yoyo: true,
          repeat: -1,
        });

        this.iconTween = this.tweens.add({
          targets: this["_platform_icon_" + i],
          y: 140 * (4 - i) - 40 - 10,
          duration: 1500,
          yoyo: true,
          repeat: -1,
        });

        this["_platform_001_" + i]
          .setInteractive({ useHandCursor: true })
          .on(
            "pointerdown",
            this.spendLadder.bind(this, this.questions[i]),
            this
          );
      }

      if (this.game.currentTile - 1 < i) {
        this["_platform_001_" + i].setTint(0x666666);
        this["_platform_icon_" + i].setTint(0x666666);
      }
    }

    if (this.game.currentTile == 4) {
      this._platform_small_border_1 = this.add
        .image(115, 140, "platformSmallBorder")
        .setDisplaySize(250, 150)
        .setOrigin(0);

      this.tileTweenBorder = this.tweens.add({
        targets: this._platform_small_border_1,
        y: 130,
        duration: 1500,
        yoyo: true,
        repeat: -1,
      });

      this.tileTween = this.tweens.add({
        targets: this._platform_001_magic,
        y: 130,
        duration: 1500,
        yoyo: true,
        repeat: -1,
      });

      this.iconTween = this.tweens.add({
        targets: this._hamochi_wizard_1,
        y: 70,
        duration: 1500,
        yoyo: true,
        repeat: -1,
      });
      this.avatarY = 280;
      this.avatarJY = 140;
      this._platform_001_magic
        .setTint("0x" + this.currentColor)
        .setInteractive({ useHandCursor: true })
        .on("pointerdown", this.spendLadder, this);
      this._hamochi_wizard_1.clearTint();
    } else if (this.game.currentTile == 5) {
      this._platformBig_001_end
        .setTint("0x" + this.nextColor)
        .setInteractive({ useHandCursor: true })
        .on("pointerdown", this.spendLadder, this);
      this._arrowRight_1.clearTint();
      this._iconPOUNCH.clearTint();
      this._hamochi_wizard_1
        .clearTint()
        .on("pointerdown", this.spendLadder, this);
      this._platform_001_magic.setTint("0x" + this.currentColor);
      this._platform_big_border = this.add
        .image(480 / 2 - 175, -390, "platformBigBorder")
        .setDisplaySize(350, 583)
        .setOrigin(0)
        .setDepth(1);

      this.tilesGroup.add(this._platform_big_border);
      this.tileTween = this.tweens.add({
        targets: [this._platformBig_001_end],
        y: -400,
        duration: 1500,
        yoyo: true,
        repeat: -1,
      });

      this.tileTweenBorder = this.tweens.add({
        targets: this._platform_big_border,
        y: -405,
        duration: 1500,
        yoyo: true,
        repeat: -1,
      });

      this.floorTextNumberTween = this.tweens.add({
        targets: this.floorTextNumber_1,
        y: 50,
        duration: 1500,
        yoyo: true,
        repeat: -1,
      });
      this.floorTextTween = this.tweens.add({
        targets: this.floorText_1,
        y: 5,
        duration: 1500,
        yoyo: true,
        repeat: -1,
      });

      this.arrowTween = this.tweens.add({
        targets: this._arrowRight_1,
        y: 20,
        duration: 1500,
        yoyo: true,
        repeat: -1,
      });
      this.iconTween = this.tweens.add({
        targets: this._iconPOUNCH,
        y: -20,
        duration: 1500,
        yoyo: true,
        repeat: -1,
      });

      this.avatarY = 140;
      this.avatarJY = 0;
    }


    //* Player Avatar *//
    for (let key of Object.keys(this.avatar)) {
      if (this.avatar[key]) {
        if (key == "body") {
          this.avatarObject.push(
            this.physics.add
              .sprite(this.avatarX, this.avatarY, key)
              .setScale(0.2)
              .setDepth(6)
              .setTint("0x" + this.avatar.color)
          );
        } else if (key != "color") {
          this.avatarObject.push(
            this.physics.add
              .sprite(this.avatarX, this.avatarY, key)
              .setScale(0.2)
              .setDepth(6)
          );
        }
      }
    }

    this.avatarBounceTweens = this.tweens.add({
      targets: this.avatarObject,
      scaleY: 0.21,
      y: "-=4",
      scaleX: 0.19,
      duration: 2000,
      ease: "Sine.easeInOut",
      repeat: -1,
      yoyo: true,
    });
    this._platformBig_001_start = this.add
      .image(65, 695, "platformBig_001")
      .setDisplaySize(350, 583)
      .setOrigin(0)
      .setTint("0x" + this.currentColor);

    this._arrowLeft_1 = this.add
      .image(330, 700, "arrowLeft")
      .setDisplaySize(75, 75)
      .setOrigin(0);
    this.tilesGroup.add(this._platformBig_001_start);
    this.tilesGroup.add(this._arrowLeft_1);

    this.showFriends()
  }
  clickSetting() {
    this.simpleClickSound.setVolume(
      store.state.settings.data.audio.sfx *
      store.state.settings.data.audio.master
    );
    this.simpleClickSound.play();
    this.scene.pause();
    this.scene.launch("Settings", {
      sceneName: "LandingScene",
    });
  }
  clickClose() {
    this.simpleClickSound.setVolume(
      store.state.settings.data.audio.sfx *
      store.state.settings.data.audio.master
    );
    this.simpleClickSound.play();
    router.push({
      name: "PageWorldMath",
    });
  }
  openCollectItem() {
    this.scene.pause();
    this.scene.launch("CollectItem", {
      type: "landingFootprint",
      sceneName: "LandingScene",
      itemCount: "X5",
      itemKey: "footprint",
      avatar: this.avatar,
      ladder: this.ladder,
      blueStar: this.blueStar,
      game: this.game,
      end: this.end,
      wizard: this.wizard,
      questions: this.questions,
      colors: this.colors,
      env: this.env,
      timestampReset: this.timestampReset,
      schoolYear: this.schoolYear,
      classroomMonth: this.classroomMonth,
      isHasSpecialItem: this.isHasSpecialItem,
    });
  }
  openCompletionGift() {
    this.scene.pause();
    this.scene.launch("CompletionGift", {
      sceneName: "LandingScene",
      avatar: this.avatar,
      ladder: this.ladder,
      blueStar: this.blueStar,
      game: this.game,
      end: this.end,
      wizard: this.wizard,
      questions: this.questions,
      colors: this.colors,
      env: this.env,
      timestampReset: this.timestampReset,
      schoolYear: this.schoolYear,
      classroomMonth: this.classroomMonth,
      isHasSpecialItem: this.isHasSpecialItem,
    });
  }
  openApiError() {
    this.scene.pause();
    this.scene.launch("ApiError", {
      sceneName: "LandingScene",
      mgs: "Not enough footprints.",
    });
  }
  spendLadder(tile) {
    this.simpleClickSound.setVolume(
      store.state.settings.data.audio.sfx *
      store.state.settings.data.audio.master
    );
    this.simpleClickSound.play();
    if (this.isClicked == false) {
      this.isClicked = true;
      if (this.ladder > 0) {
        if (this.game.currentTile != 5) {
          this.ladder = this.ladder - 1;

          this.footprintText.setText(this.ladder + "");
          this._icon_foot_spend = this.add
            .image(this.avatarX - 20, this.avatarY, "footSpend")
            .setDisplaySize(60, 38)
            .setOrigin(0)
            .setDepth(7);
        }
        this.time.delayedCall(700, () => {
          this.jumpToNext(tile);
        });
        this.tweens.add({
          targets: [this._icon_foot_spend],
          y: this.avatarY - 100,
          alpha: 0,
          duration: 3000,
          ease: "Sine.easeOut",
        });
      } else {
        this.sfxError.setVolume(
          store.state.settings.data.audio.sfx *
          store.state.settings.data.audio.master
        );
        this.sfxError.play();
        this.showError(i18n.t("miniGames.towerClimbing.footprintError"));
        this.speechRound = this.add
          .image(this.avatarObject[0].x, this.avatarY - 80, "speechRound")
          .setScale(0.0)
          .setDepth(7);

        this.tweens.add({
          targets: [this.speechRound],
          scaleX: 0.35,
          scaleY: 0.35,
          duration: 300,
          ease: "Sine.easeOut",
          onComplete: () => {
            this.time.delayedCall(400, () => {
              this.avatarMask = this.add
                .image(this.avatarObject[0].x, this.avatarY, "maskSad")
                .setScale(0.2)
                .setDepth(6);
            });

            this.time.delayedCall(1000, () => {
              this.avatarMask.destroy();
              this.speechRound.setVisible(false);
              this.isClicked = false;
            });
          },
        });
      }
    }
  }
  showError(mgs) {
    const words = mgs.split(" ");
    const lines = [];

    while (words.length > 0) {
      lines.push(words.splice(0, 3).join(" "));
    }

    const centerX = this.cameras.main.centerX;
    const centerY = this.cameras.main.centerY - 50;
    this.tweens.add({
      targets: this.modelbg,
      alpha: 0.5,
      duration: 200,
      ease: "Sine.easeInOut",
    });
    lines.map((line, index) => {
      const text = this.add
        .text(centerX, centerY + (index - (lines.length - 1) / 2) * 30, line, {
          fontFamily: "Sassoon, sans-serif",
          fontSize: 20,
          fill: "#ffffff",
          stroke: "#D50000",
          strokeThickness: 2,
        })
        .setDepth(10);

      // Center the text
      text.setOrigin(0.5, 0.5);

      this.tweens.add({
        targets: text,
        scaleX: 1.5,
        scaleY: 1.5,
        duration: 200,
        ease: "Sine.easeInOut",
        onComplete: () => {
          this.tweens.add({
            targets: this.modelbg,
            alpha: 0,
            duration: 200,
            delay: 1000,
            ease: "Sine.easeInOut",
          });
          this.tweens.add({
            targets: text,
            scaleX: 0,
            scaleY: 0,
            duration: 200,
            ease: "Sine.easeInOut",
            delay: 1000,
          });
        },
      });
      return text;
    });
  }
  jumpToNext(tile) {
    this.avatarBounceTweens.stop();
    this.sfxAvatarJump.setVolume(
      store.state.settings.data.audio.sfx *
      store.state.settings.data.audio.master
    );
    this.sfxAvatarJump.play();
    const centerX = this.avatarX;
    const centerY = this.avatarJY;
    this.spriteJump.y = this.avatarObject[0].y;
    this.spriteJump.setAlpha(1);
    this.spriteJump.play("avatarJump");
    this.tweens.add({
      targets: this.avatarObject,
      scaleY: 0.17,
      y: "+=9",
      duration: 100, // Duration of the tween in milliseconds
      ease: "Power1", // Easing function (you can adjust this)
      yoyo: true,
      onComplete: () => {
        this.tweens.add({
          targets: this.avatarObject,
          y: "-=200",
          ease: "Power1",
          duration: 400,
          onComplete: () => {
            if (this.tileTween) this.tileTween.remove();
            if (this.arrowTween) this.arrowTween.remove();
            if (this.iconTween) this.iconTween.remove();
            if (this.floorTextTween) this.floorTextTween.remove();
            if (this.floorTextNumberTween) this.floorTextNumberTween.remove();
            if (this._platform_big_border) this._platform_big_border.destroy();
            if (this.tileTweenBorder) {
              this.tileTweenBorder.remove();
            }
            this.tweens.add({
              targets: this.avatarObject,
              x: centerX,
              y: centerY,
              ease: "Power1",
              duration: 400,
              onComplete: () => {
                this.spriteJump.visible = false;
                this.tweens.add({
                  targets: this.avatarObject,
                  scaleY: 0.2,
                  y: "+=9",
                  ease: "Power1",
                  duration: 200,
                  yoyo: true,
                  onComplete: () => {
                    this.sfxEmoji.setVolume(
                      store.state.settings.data.audio.sfx *
                      store.state.settings.data.audio.master
                    );
                    this.sfxEmoji.play();
                    this.speech = this.add
                      .image(centerX + 50, centerY - 40, "speech")
                      .setScale(0.0)
                      .setDepth(7);

                    this.mark = this.add
                      .image(centerX + 50, centerY - 40, "excl")
                      .setScale(0.0)
                      .setDepth(7);
                    this.tweens.add({
                      targets: [this.mark],
                      scaleX: 0.25,
                      scaleY: 0.25,
                      duration: 300,
                      ease: "Sine.easeOut",
                    });
                    this.tweens.add({
                      targets: [this.speech],
                      scaleX: 0.35,
                      scaleY: 0.35,
                      duration: 300,
                      ease: "Sine.easeOut",
                      onComplete: () => {
                        this.time.delayedCall(500, () => {
                          // this.spriteLand.visible = false;
                          this.time.delayedCall(700, () => {
                            if (this.game.currentTile < 4) {
                              this.set(tile);
                            } else if (this.game.currentTile == 4) {
                              this.goWizard();
                            } else {
                              this.game.currentTile =
                                this.game.currentTile == 5
                                  ? 1
                                  : this.game.currentTile + 1;
                              this.game.currentFloor =
                                this.game.currentTile == 1
                                  ? this.game.currentFloor + 1
                                  : this.game.currentFloor;
                              this.sfxNextFloor.setVolume(
                                store.state.settings.data.audio.sfx *
                                store.state.settings.data.audio.master
                              );
                              this.sfxNextFloor.play();
                              let token =
                                store.state.auth.data.Session.token;
                              const headers = {
                                Authorization: `Bearer ${token}`,
                              };

                              axios
                                .post(
                                  `${this.env.VUE_APP_URL_API_GAME}/api/v2/en/game/dailyGame/move`,
                                  { schoolYear: this.schoolYear, classroomMonth: this.classroomMonth },
                                  { headers }
                                )
                                .then((response) => {
                                  if (store.state.auth.data.User.type != "adult") {
                                    this.submitLog()
                                  }
                                  // Process the data returned from the API
                                  this.questions =
                                    response.data.Data.Question.reverse();
                                  this.scene.pause();
                                  this.scene.launch("CompletionGift", {
                                    sceneName: "LandingScene",
                                    avatar: this.avatar,
                                    ladder: this.ladder,
                                    blueStar: this.blueStar,
                                    game: this.game,
                                    end: this.end,
                                    wizard: this.wizard,
                                    questions: this.questions,
                                    colors: this.colors,
                                    env: this.env,
                                    timestampReset: this.timestampReset,
                                    schoolYear: this.schoolYear,
                                    classroomMonth: this.classroomMonth,
                                    isHasSpecialItem: this.isHasSpecialItem,
                                  });
                                  this.tweens.add({
                                    targets: this.tilesGroup.getChildren(),
                                    y: "+=1093", // Y position at the bottom
                                    duration: 1000, // Duration of the tween in milliseconds
                                    ease: "Linear", // Easing function (linear for constant speed)
                                  });

                                  this.removeFriends()
                                  this.tweens.add({
                                    targets: this.avatarObject,
                                    y: "+=1093", // Y position at the bottom
                                    duration: 1000, // Duration of the tween in milliseconds
                                    ease: "Linear",
                                    onComplete: () => {
                                      this.tweens.add({
                                        targets: this.avatarObject,
                                        y: "-=350", // Y position at the bottom
                                        duration: 1000, // Duration of the tween in milliseconds
                                        ease: "Linear",
                                        onComplete: async () => {
                                          await this.apiCall(); // Get new friend data

                                          // Set avatars and queue image assets for loading
                                          this.friends.forEach(friend => {
                                            friend.avaratImages = this.selectSkin(JSON.parse(friend.Player.avatar));
                                            for (let key of Object.keys(friend.avaratImages)) {
                                              if (friend.avaratImages[key] && key !== "color") {
                                                this.load.image(key + "_" + friend.mochiId, friend.avaratImages[key]);
                                              }
                                            }
                                          });

                                          // Wait for loading to finish, then show friends
                                          this.load.once('complete', () => {
                                            console.log("Assets loaded successfully");
                                            this.scene.start("LandingScene", {
                                              avatar: this.avatar,
                                              ladder: this.ladder,
                                              blueStar: this.blueStar,
                                              game: this.game,
                                              end: this.end,
                                              wizard: this.wizard,
                                              colors: this.colors,
                                              questions: this.questions,
                                              env: this.env,
                                              timestampReset: this.timestampReset,
                                              schoolYear: this.schoolYear,
                                              classroomMonth: this.classroomMonth,
                                              isHasSpecialItem: this.isHasSpecialItem,
                                            });
                                          });

                                          this.load.start(); // Trigger the asset loading

                                        },
                                      });
                                    },
                                  });

                                })
                                .catch((error) => {
                                  // Handle any errors that occur during the API call
                                  console.error("Error:", error);
                                });
                            }
                          });
                        });
                      },
                    });
                  },
                });
              },
            });
          },
        });
      },
    });
  }
  set(tile) {
    this.sfxTransition.setVolume(
      store.state.settings.data.audio.sfx *
      store.state.settings.data.audio.master
    );
    this.sfxTransition.play();
    this.cameras.main.fadeOut(1000, 0, 0, 0);
    let game_cache_data = {};
    game_cache_data.q = tile.questionKey;
    game_cache_data.c = tile.chapterKey;
    game_cache_data.g = tile.gameCode;

    store.commit("updateMiniGame", game_cache_data);
    if (store.state.settings.data.debug) {
      this.time.delayedCall(1000, () => {
        router.push({
          name: "PageExploreDailyGameDetails",
        });
      });
    } else {
      this.time.delayedCall(1000, () => {
        router.push({
          name: "PageExploreDailyGamePlay",
        });
      });
    }
  }
  updateRemaining(distance) {
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    )
      .toString()
      .padStart(2, "0");
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      .toString()
      .padStart(2, "0");
    const seconds = Math.floor((distance % (1000 * 60)) / 1000)
      .toString()
      .padStart(2, "0");
    this.resetText.setText(
      `${i18n.t("string.resetIn")} ${hours}:${minutes}:${seconds}`
    );
  }
  tick() {
    const currentTime = new Date();
    const distance = Math.max(this.timestampReset - currentTime, 0);

    if (distance === 0) {
      clearInterval(this.timerInterval);

      this.rechargebale = true;
      this.resetText.setText(`${i18n.t("string.resetIn")} 00:00:00`);
      this.time.delayedCall(1000, () => {
        this.openCollectItem();
      });
    } else {
      this.updateRemaining(distance);
    }
  }
  collectStar() {
    let star = store.state.miniGame.data.star;
    let token = store.state.auth.data.Session.token;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    axios
      .post(
        `${this.env.VUE_APP_URL_API_GAME}/api/v1/en/game/item/updateMany`,
        {
          data:
            '[{"action":"add","itemKey":"C000040","quantity":' + star + "}]",
        },
        { headers }
      )
      .then((response) => {
        this.blueStar = response.data[0].quantity;
        store.dispatch("resetMiniGame");
        this.scene.pause();
        this.scene.launch("CollectItem", {
          type: "landingBlueStar",
          sceneName: "LandingScene",
          itemCount: "+" + star,
          itemKey: "C000040",
          avatar: this.avatar,
          ladder: this.ladder,
          blueStar: this.blueStar,
          game: this.game,
          end: this.end,
          wizard: this.wizard,
          questions: this.questions,
          colors: this.colors,
          env: this.env,
          timestampReset: this.timestampReset,
          schoolYear: this.schoolYear,
          classroomMonth: this.classroomMonth,
          isHasSpecialItem: this.isHasSpecialItem,
        });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
  submitLog() {
    let token = store.state.auth.data.Session.token;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    axios
      .post(
        `${this.env.VUE_APP_URL_API_LOG}/api/v1/en/dailyGameProgress/add`,
        {
          institutionId: store.state.auth.data.Institution ? store.state.auth.data.Institution.id : null,
          classroomId: store.state.auth.data.Classroom ? store.state.auth.data.Classroom.id : null,
          studentId: store.state.auth.data.Classroom ? store.state.auth.data.User.id : null,
          userId: store.state.auth.data.Classroom ? null : store.state.auth.data.User.id,
          schoolYear: this.schoolYear,
          classroomMonth: this.classroomMonth,
          mochiId: store.state.auth.data.Player.mochiId,
          currentFloor: this.game.currentFloor,
          currentTile: this.game.currentTile,
        },
        { headers }
      )
      .catch((error) => {
        console.error("Error:", error);
      });
  }
  resetLevel() {
    this.scene.pause();
    this.scene.launch("Confirmation", {
      sceneName: "LandingScene",
      env: this.env,
      classroomMonth: this.classroomMonth,
      schoolYear: this.schoolYear
    });
  }
  resetLevel1() {
    this.resetBtn
      .off("pointerdown", this.resetLevel, this)
      .removeInteractive();
    let token = store.state.auth.data.Session.token;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    axios
      .post(
        `${this.env.VUE_APP_URL_API_GAME}/api/v2/en/game/dailyGame/reset`,
        { schoolYear: this.schoolYear, classroomMonth: this.classroomMonth },
        { headers }
      ).then(() => {
        window.location.reload();
      })
      .catch((error) => {
        // Handle any errors that occur during the API call
        console.error("Error:", error);
      });
  }
  collectFoot() {
    let token = store.state.auth.data.Session.token;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    axios
      .post(
        `${this.env.VUE_APP_URL_API_GAME}/api/v1/en/game/footprint/reset`,
        {},
        { headers }
      )
      .then((response) => {
        this.ladder = response.data.Footprint.quantity;
        this.footprintText.setText(this.ladder + "");
        this.timestampReset = moment(response.data.TimestampReset);

        this.tick();
        this.timerInterval = setInterval(this.tick.bind(this), 1000);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
  goWizard() {
    this.sfxTransition.setVolume(
      store.state.settings.data.audio.sfx *
      store.state.settings.data.audio.master
    );
    this.sfxTransition.play();
    this.cameras.main.fadeOut(1000, 0, 0, 0);
    this.time.delayedCall(1000, () => {
      this.scene.start("WizardScene", {
        avatar: this.avatar,
        ladder: this.ladder,
        blueStar: this.blueStar,
        game: this.game,
        end: this.end,
        wizard: this.wizard,
        colors: this.colors,
        questions: this.questions,
        env: this.env,
        timestampReset: this.timestampReset,
        schoolYear: this.schoolYear,
        classroomMonth: this.classroomMonth,
        isHasSpecialItem: this.isHasSpecialItem,
      });
    });
  }
  update() {
    if (this.avatarObject[0]) {
      this.spriteJump.x = this.avatarObject[0].x;
    }
  }
  showFriends() {
    this.friendDisplays = []; // store references for later removal

    this.friends.forEach(friend => {
      let friendAvatar = [];
      let friendY = 700 - friend.Player.currentTile * 140;

      for (let key of Object.keys(friend.avaratImages)) {
        if (friend.avaratImages[key]) {
          if (key == "body") {
            var body = this.add.image(170, friendY, key + "_" + friend.mochiId).setScale(0.18).setDepth(5);
            if (friend.Player.currentTile > this.game.currentTile) body.setTint(0x666666);
            friendAvatar.push(body);

            let bodyOverlay = this.add
              .image(170, friendY, key + "_" + friend.mochiId)
              .setTint(friend.Player.currentTile > this.game.currentTile ? 0x666666 : "0x" + friend.avaratImages.color)
              .setScale(0.18)
              .setAlpha(0.3)
              .setDepth(5);
            friendAvatar.push(bodyOverlay);
          } else if (key != "color" && key != "right") {
            let apprel = this.add.image(170, friendY, key + "_" + friend.mochiId).setScale(0.18).setDepth(5);
            if (friend.Player.currentTile > this.game.currentTile) apprel.setTint(0x666666);
            friendAvatar.push(apprel);
          }
        }
      }

      const friendName = this.add
        .text(170, friendY + 55, friend.mochiId, {
          color: "#fff",
          fontSize: "11px",
          fontFamily: "Sassoon, sans-serif",
        })
        .setOrigin(0.5)
        .setDepth(5)
        .setStroke('#000', 5);

      this.friendDisplays.push(...friendAvatar, friendName);

      if (this.game.currentTile == friend.Player.currentTile) {
        this.tweens.add({
          targets: [...friendAvatar, friendName],
          y: "-=10",
          duration: 1500,
          repeat: -1,
          yoyo: true,
        });
      } else {
        this.tweens.add({
          targets: friendAvatar,
          scaleY: 0.185,
          y: "-=3",
          scaleX: 0.175,
          duration: 2000,
          ease: "Sine.easeInOut",
          repeat: -1,
          yoyo: true,
        });
      }
    });
  }
  removeFriends() {
    if (!this.friendDisplays) return;

    this.friendDisplays.forEach(display => {
      if (display && display.destroy) {
        display.destroy(); // safely destroy GameObjects
      }
    });

    this.friendDisplays = [];
  }
  async apiCall() {
    let token =
      store.state.auth.data.Session.token;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    await axios
      .post(
        `${this.env.VUE_APP_URL_API_GAME}/api/v2/en/game/dailyGame/visit`,
        { schoolYear: this.schoolYear, classroomMonth: this.classroomMonth },
        { headers }
      )
      .then((response) => {
        // Process the data returned from the API
        this.friends = response.data.Friend
        this.registry.set('towerStrangers', this.friends);
        this.questions = response.data.Data.Question.reverse();
      })
      .catch((error) => {
        // Handle any errors that occur during the API call
        console.error("Error:", error);
      });
  }
  selectSkin(avatarData) {
    this.skin = store.state.skin.data
    this.hatData = store.state.apparel.data
    var bodyData = this.skin.body;
    var outlineData = this.skin.outline;
    var mouthData = this.skin.mouth;
    var shadowData = this.skin.shadow;
    var eyeData = this.skin.eye;
    var hairData = this.skin.hair;
    var cheekData = this.skin.cheek;
    var outline = avatarData.body;
    var mouth = avatarData.mouth;
    var hat = avatarData.hat;
    var left = avatarData.left;
    var right = avatarData.right;
    var back = avatarData.back;

    var _avatarOutline = outlineData.filter(function (entry) {
      return entry.character == outline;
    });
    var avatarOutline = JSON.parse(_avatarOutline[0].images).F0.url;

    var _avatarBody = bodyData.filter(function (entry) {
      return entry.character == outline;
    });
    var avatarBody = JSON.parse(_avatarBody[0].images).F0.url;

    var _avatarMouth = mouthData.filter(function (entry) {
      return entry.character == mouth;
    });
    var avatarMouth = JSON.parse(_avatarMouth[0].images).F0.url;

    if (hat) {
      var _avatarHat = this.hatData.filter(function (entry) {
        return entry.key == hat;
      });
      var avatarHat = JSON.parse(_avatarHat[0].images).apparel.url;
    }
    if (left) {
      var _avatarLeft = this.hatData.filter(function (entry) {
        return entry.key == left;
      });
      var avatarLeft = JSON.parse(_avatarLeft[0].images).apparel.url;
    }
    if (right) {
      var _avatarRight = this.hatData.filter(function (entry) {
        return entry.key == right;
      });
      var avatarRight = JSON.parse(_avatarRight[0].images).apparel.url;
    }
    if (back) {
      var _avatarBack = this.hatData.filter(function (entry) {
        return entry.key == back;
      });
      var avatarBack = JSON.parse(_avatarBack[0].images).apparel.url;
    }

    var avatarShadow = JSON.parse(shadowData[0].images).F0.url;
    var avatarEye = JSON.parse(eyeData[0].images).F0.url;
    var avatarHair = JSON.parse(hairData[0].images).F0.url;
    var avatarCheek = JSON.parse(cheekData[0].images).F0.url;
    var avatarColor = avatarData.pColor;

    let avatar = {
      shadow: null,
      back: null,
      right: null,
      body: null,
      outline: null,
      cheek: null,
      mouth: null,
      eye: null,
      hair: null,
      left: null,
      hat: null,
      color: null,
    }
    avatar.back = avatarBack;
    avatar.body = avatarBody;
    avatar.eye = avatarEye;
    avatar.hat = avatarHat;
    avatar.left = avatarLeft;
    avatar.mouth = avatarMouth;
    avatar.right = avatarRight;
    avatar.shadow = avatarShadow;
    avatar.outline = avatarOutline;
    avatar.cheek = avatarCheek;
    avatar.hair = avatarHair;
    avatar.color = avatarColor;

    return avatar
  }
}
